/* eslint-disable prettier/prettier */
/* eslint-disable */

import genericReducers from '../genericReducer';
import { connectReducers } from '../../utils';
import { IReducers } from '../index';

import { GET_INTEREST_GROUP_KINDS } from '../../actions';
import { REQUEST, FAILURE, SUCCESS } from '../../actions/utils';

import { ICommonResponse, IInterestGroupKind } from '../../api/types';

export type InterestGroupKindsState = ICommonResponse<IInterestGroupKind>;

const initialState = {
  content: [],
  loading: false,
} as InterestGroupKindsState;
const generic = genericReducers<InterestGroupKindsState>();
const interestGroupKinds: IReducers<InterestGroupKindsState> = {
  [GET_INTEREST_GROUP_KINDS[REQUEST]]: generic.get.request,
  [GET_INTEREST_GROUP_KINDS[SUCCESS]]: generic.get.success,
  [GET_INTEREST_GROUP_KINDS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, interestGroupKinds);
